import moment from '@tw/moment-cached/module/timezone';

export const convertDataToStats = (data, start, end, isOneDay?: boolean) => {
  if (!data?.data) {
    return [];
  }
  const { metricsBreakdown } = data?.data?.[0] || {};
  if (!metricsBreakdown?.length) {
    return [];
  }
  if (isOneDay === undefined) isOneDay = moment(start).diff(end, 'days') === 0;
  const stats: any[] = [];
  if (isOneDay) {
    const hours = metricsBreakdown?.reduce((acc, x) => {
      const momentTime = moment(x.date);
      const hour = momentTime.hour();
      return {
        hours: {
          ...acc.hours,
          [hour]: x.metrics,
        },
        start: momentTime.startOf('day').format(),
        end: momentTime.endOf('day').format(),
        id: momentTime.format('ll'),
      };
    }, {});
    stats.push(hours);
  } else {
    metricsBreakdown.forEach((x) => {
      const momentTime = moment(x.date);
      const day = {
        start: momentTime.startOf('day').format(),
        end: momentTime.endOf('day').format(),
        id: momentTime.format('ll'),
        hours: { 0: x.metrics },
      };
      stats.push(day);
    });
  }
  return stats;
};
